<template>
  <div class="member-dashboard">
    <gc-adsense-modal></gc-adsense-modal>
    <Header :current-member="sections.member_data" />
    <template v-if="!error.message || !error.message.length">
      <Section v-if="!reduceAds && !adsBlockerEnabled">
        <GcHorizontalAdsense
          :slot-id="horizontalAdFormat === 'autorelaxed' ? '2147021260' : '1228464954'"
          :ad-format="horizontalAdFormat"
        />
      </Section>
      <Section title="New Tutorials For You">
        <Tutorials :loading="loading" :tutorials="tutorialsWithAds" />
      </Section>
      <Section title="New Questions">
        <Questions :loading="loading" :questions="questionsWithAds" />
      </Section>
      <Section title="New Activity in Groups">
        <Groups :loading="loading" :group-content="sections.group_contents" />
      </Section>
      <Section title="Recommended Engineers">
        <Engineers :loading="loading" :engineers="sections.engineers" />
      </Section>
      <Section title="New Blog Posts">
        <BlogPosts :loading="loading" :blog-posts="sections.blog_posts" />
      </Section>
      <Section v-if="!reduceAds && !adsBlockerEnabled">
        <GcHorizontalAdsense
          :slot-id="horizontalAdFormat === 'autorelaxed' ? '6431549500' : '2492950323'"
          :ad-format="horizontalAdFormat"
        />
      </Section>
      <Section title="New Models">
        <Models :loading="loading" :models="sections.models" />
      </Section>
    </template>
    <template v-else>
      <Section>
        <ContentError :error="error" />
      </Section>
    </template>
  </div>
</template>

<script>
import Header from "./dashboard/Header";
import Section from "./dashboard/shared/Section";
import Groups from "./dashboard/sections/Groups";
import Engineers from "./dashboard/sections/Engineers";
import BlogPosts from "./dashboard/sections/BlogPosts";
import Models from "./dashboard/sections/Models";
import Tutorials from "./dashboard/sections/Tutorials";
import Questions from "./dashboard/sections/Questions";
import ContentError from "./dashboard/shared/ContentError";
import GcAdsenseModal from "../../shared/adsense/GcAdsenseModal";
import GcHorizontalAdsense from "../../shared/adsense/GcHorizontalAdsense";
import api from "./dashboard/api";

const errorBase = {
  message: null,
  link: null
};

export default {
  name: "MemberDashboard",
  data() {
    return {
      loading: true,
      sections: {},
      adsBlockerEnabled: true,
      error: {
        ...errorBase
      }
    };
  },
  computed: {
    reduceAds() {
      return Grabcad.member_reduce_ads;
    },
    questionsWithAds() {
      return this.addAdsToItems(this.sections.questions, [
        "2407483555",
        "1267492393"
      ]);
    },
    tutorialsWithAds() {
      return this.addAdsToItems(this.sections.tutorials, [
        "4466684779",
        "5496713140"
      ]);
    },
    horizontalAdFormat() {
      return Grabcad.asense.horizontal_ad_format === "autorelaxed" ? "autorelaxed" : "horizontal";
    }
  },
  components: {
    ContentError,
    Header,
    Section,
    Tutorials,
    Groups,
    Questions,
    Engineers,
    BlogPosts,
    Models,
    GcHorizontalAdsense,
    GcAdsenseModal
  },
  methods: {
    handleRemoveResponse({ data }) {
      this.sections.engineers = data.engineers;
      if (!data.engineers.length) {
        this.error.message = "No engineers to display.";
      }
    },

    handleRemoveError(engineersBackup) {
      this.engineers = engineersBackup;
    },

    handleRemoveEngineer(id) {
      const engineersBackup = this.sections.engineers.slice();
      this.sections.engineers = this.sections.engineers.filter(
        e => e.id !== id
      );
      api
        .delete(`/engineers/${id}`)
        .then(res => this.handleRemoveResponse(res))
        .catch(() => this.handleRemoveError(engineersBackup));
    },

    handleResponse({ data }) {
      this.loading = false;
      this.sections = data;
    },

    handleError() {
      this.loading = false;
      this.error.message = "Couldn't load Dashboard content. Click to reload";
      this.error.link = "/dashboard";
    },
    addAdsToItems(items, slotIds) {
      if (!items || !items.length) return [];
      if (this.adsBlockerEnabled) return items;

      let result = [];
      let slotIndex = 0;

      for (let i = 0; i < items.length; i++) {
        if (i === 0 || ((i - 2) % 2 === 0 && !this.reduceAds)) {
          result.push({ isAd: true, slotId: slotIds[slotIndex] });
          slotIndex = (slotIndex + 1) % slotIds.length;
        }
        result.push(items[i]);
      }

      return result;
    },
    checkAdBlock() {
      const url = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
      return fetch(url, { method: "HEAD" })
      .then(response => {
        const contentLength = response.headers.get('content-length');
				return contentLength === null || !(parseInt(contentLength) > 40000);
      })
      .catch(() => true);
    }
  },
  mounted() {
    this.$eventHub.$on("removeEngineer", this.handleRemoveEngineer);
    this.checkAdBlock().then(result => {
      this.adsBlockerEnabled = result;

      api
        .get("/")
        .then(res => this.handleResponse(res))
        .catch(() => this.handleError());
    });
  }
};
</script>

<style lang="scss">
.member-dashboard {
  background: $dashboard-background;
}
</style>
